module.exports = __webpack_public_path__ + "img/user.4784fe88.svg";